/*
* Created on Feb 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';

const TableHeadFieldFilerComponent = ({field, dispatch, currentFilters = []}) => {
    const toggleFilter = (e) => {
        const checked = e.target.checked;
        let newVal = [];
        if (checked) {
            newVal = [...currentFilters, e.target.value];
        } else {
            newVal = currentFilters.filter(f => f !== e.target.value);
        }
        dispatch({type: 'toggle_filter', payload: {field_id: field.field_id, filters: newVal}});
    }

    return (
        <div className="col-filter filter-off">
            <div className="comp-dropdown drop-adjustable hide">
                <ul className="comp-dropdown-menu">
                    <li className="section">
                        {
                            field.filters.map((f, index) => {
                                const isChecked = currentFilters.includes(f.value);
                                return (
                                    <div className="section-items selection" key={index}>
                                        <div className="comp-checkbox">
                                            <input
                                                type="checkbox"
                                                id={`f-cb-${field.field_name}-${index}`}
                                                value={f.value}
                                                checked={isChecked}
                                                onChange={toggleFilter}
                                            />
                                            <label htmlFor={`f-cb-${field.field_name}-${index}`} className="comp-label">{f.name}</label>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default TableHeadFieldFilerComponent;
